import React from "react";
import { LeftAngle } from "../icons";
import "./Button.css";

const IconButton = ({
	icon: Icon = LeftAngle,
	type = "button",
	value,
	label,
	className = "",
	bordered = false,
	"aria-label": ariaLabel,
	...props
}) => (
	<button
		className={`icon-button${bordered ? " icon-button--bordered" : ""}${className ? ` ${className}` : ""}`}
		type={type}
		aria-label={ariaLabel || (!value ? label : undefined)}
		{...props}
	>
		<Icon aria-hidden="true" focusable="false" />
		{value && <span className="button-value">{value}</span>}
	</button>
);

export default IconButton;
